// const displayValue = (value) => {
//   if (Array.isArray(value)) return value.map((item) => item?.name || item).filter(Boolean).join(', ');
//   return value?.name || value || '';
// };

// export const getMergeFieldValue = (key, { member = {}, organization, branch = {}, event = {} } = {}) => {
//   const firstName = member.first_name || '';
//   const lastName = member.last_name || '';
//   const organizationRecord = typeof organization === 'object' && organization ? organization : {};
//   const churchName = typeof organization === 'string'
//     ? organization
//     : organizationRecord.name || organizationRecord.title || organizationRecord.organization_name || organizationRecord.church_name || '';

//   const values = {
//     '{FirstName}': firstName,
//     '{LastName}': lastName,
//     '{FullName}': member.name || member.full_name || `${firstName} ${lastName}`.trim(),
//     '{Group}': displayValue(member.group),
//     '{Branch}': displayValue(member.branch) || branch.name || branch.branch_name || '',
//     '{Email}': member.email || '',
//     '{Phone}': member.phone || '',
//     '{Status}': displayValue(member.status),
//     '{ChurchName}': churchName,
//     '{PastorName}': branch.pastor_name || organizationRecord.pastorName || organizationRecord.leader_name || '',
//     '{ChurchAddress}': branch.address || organizationRecord.church_address || '',
//     '{EventTitle}': event.title || event.name || '',
//     '{Date}': event.date || event.event_date || '',
//     '{Time}': event.time || event.event_time || '',
//     '{Venue}': event.venue || event.location || ''
//   };

//   return values[key] || '';
// };













const displayValue = (value) => {
  if (Array.isArray(value)) return value.map((item) => item?.name || item).filter(Boolean).join(', ');
  if (value && typeof value === 'object') return value.name || value.title || value.value || '';
  return value || '';
};

export const getMergeFieldValue = (key, { 
  member = {}, 
  organization = {}, 
  branch = {}, 
  event = {} 
} = {}) => {
  // Normalize inputs
  const memberData = member || {};
  const organizationData = typeof organization === 'object' && organization ? organization : {};
  const branchData = typeof branch === 'object' && branch ? branch : {};
  const eventData = event || {};

  // Get first name and last name
  const firstName = memberData.first_name || memberData.firstName || '';
  const lastName = memberData.last_name || memberData.lastName || '';
  const fullName = memberData.name || memberData.full_name || `${firstName} ${lastName}`.trim();

  // Get church name from organization
  const churchName = organizationData.name || 
                     organizationData.title || 
                     organizationData.organization_name || 
                     organizationData.church_name || 
                     '';

  // Get branch name - try multiple sources
  const branchName = branchData.name || 
                     branchData.branch_name || 
                     branchData.title || 
                     (memberData.branch && typeof memberData.branch === 'object' ? memberData.branch.name : memberData.branch) ||
                     '';

  // Get pastor name - try multiple sources
  const pastorName = branchData.pastor_name || 
                     branchData.pastorName ||
                     organizationData.pastor_name ||
                     organizationData.pastorName ||
                     organizationData.leader_name ||
                     organizationData.leaderName ||
                     '';

  // Get branch address
  const branchAddress = branchData.address || 
                        branchData.church_address ||
                        organizationData.address ||
                        organizationData.church_address ||
                        '';

  // Build values object with all possible fields
  const values = {
    // Member fields
    '{FirstName}': firstName,
    '{LastName}': lastName,
    '{FullName}': fullName,
    '{Name}': fullName,
    '{Email}': memberData.email || '',
    '{Phone}': memberData.phone || memberData.phone_number || '',
    '{Gender}': displayValue(memberData.gender),
    '{Group}': displayValue(memberData.group),
    '{Branch}': branchName,
    '{Status}': displayValue(memberData.status),
    '{City}': memberData.city || branchData.city || '',
    '{State}': memberData.state || branchData.state || '',
    '{Country}': memberData.country || branchData.country || '',
    '{MemberCode}': memberData.member_code || memberData.code || '',
    '{Occupation}': memberData.occupation || '',
    '{Dob}': memberData.dob || memberData.date_of_birth || '',
    '{JoinedDate}': memberData.joined_date || memberData.joinedDate || '',

    // Organization fields
    '{ChurchName}': churchName,
    '{ChurchEmail}': organizationData.email || '',
    '{ChurchPhone}': organizationData.phone || organizationData.phone_number || '',
    '{ChurchAddress}': branchAddress || organizationData.address || '',
    '{ChurchCity}': organizationData.city || branchData.city || '',
    '{ChurchState}': organizationData.state || branchData.state || '',
    '{ChurchCountry}': organizationData.country || branchData.country || '',
    '{PastorName}': pastorName,
    '{OrganizationName}': churchName,

    // Branch fields
    '{BranchName}': branchName,
    '{BranchAddress}': branchAddress,
    '{BranchCity}': branchData.city || '',
    '{BranchState}': branchData.state || '',
    '{BranchCountry}': branchData.country || '',
    '{BranchPhone}': branchData.phone || branchData.phone_number || '',
    '{BranchEmail}': branchData.email || '',

    // Event fields
    '{EventTitle}': eventData.title || eventData.name || '',
    '{EventDate}': eventData.date || eventData.event_date || '',
    '{EventTime}': eventData.time || eventData.event_time || '',
    '{EventVenue}': eventData.venue || eventData.location || '',
    '{EventAddress}': eventData.address || eventData.location || '',

    // System fields
    '{CurrentDate}': new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    '{CurrentTime}': new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }),
    '{CurrentDateTime}': new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }),
  };

  // Debug logging
  console.log('🔍 Merge Field Lookup:', {
    key,
    branchData,
    memberData,
    organizationData,
    value: values[key],
    availableKeys: Object.keys(values)
  });

  return values[key] || '';
};

/**
 * Get all available merge field keys with their current values
 */
export const getAllMergeFieldValues = (context = {}) => {
  const keys = [
    '{FirstName}', '{LastName}', '{FullName}', '{Name}',
    '{Email}', '{Phone}', '{Gender}', '{Group}', '{Branch}', '{Status}',
    '{City}', '{State}', '{Country}', '{MemberCode}', '{Occupation}',
    '{Dob}', '{JoinedDate}',
    '{ChurchName}', '{ChurchEmail}', '{ChurchPhone}', '{ChurchAddress}',
    '{ChurchCity}', '{ChurchState}', '{ChurchCountry}', '{PastorName}',
    '{OrganizationName}',
    '{BranchName}', '{BranchAddress}', '{BranchCity}', '{BranchState}',
    '{BranchCountry}', '{BranchPhone}', '{BranchEmail}',
    '{EventTitle}', '{EventDate}', '{EventTime}', '{EventVenue}', '{EventAddress}',
    '{CurrentDate}', '{CurrentTime}', '{CurrentDateTime}'
  ];

  const values = {};
  keys.forEach(key => {
    values[key] = getMergeFieldValue(key, context);
  });

  return values;
};

/**
 * Get merge fields grouped by category
 */
export const getMergeFieldsByCategory = (context = {}) => {
  const allValues = getAllMergeFieldValues(context);
  
  return {
    'Member': {
      fields: ['{FirstName}', '{LastName}', '{FullName}', '{Name}', '{Gender}', '{Dob}', '{JoinedDate}'],
      values: allValues
    },
    'Contact': {
      fields: ['{Email}', '{Phone}'],
      values: allValues
    },
    'Church': {
      fields: ['{Group}', '{Branch}', '{Status}', '{MemberCode}', '{Occupation}'],
      values: allValues
    },
    'Location': {
      fields: ['{City}', '{State}', '{Country}'],
      values: allValues
    },
    'Organization': {
      fields: ['{ChurchName}', '{ChurchEmail}', '{ChurchPhone}', '{ChurchAddress}', '{ChurchCity}', '{ChurchState}', '{ChurchCountry}', '{PastorName}'],
      values: allValues
    },
    'Branch': {
      fields: ['{BranchName}', '{BranchAddress}', '{BranchCity}', '{BranchState}', '{BranchCountry}', '{BranchPhone}', '{BranchEmail}'],
      values: allValues
    },
    'Event': {
      fields: ['{EventTitle}', '{EventDate}', '{EventTime}', '{EventVenue}', '{EventAddress}'],
      values: allValues
    },
    'System': {
      fields: ['{CurrentDate}', '{CurrentTime}', '{CurrentDateTime}'],
      values: allValues
    }
  };
};

/**
 * Preview message with merge fields replaced
 */
export const previewMessage = (template, context = {}) => {
  if (!template) return '';
  
  let preview = template;
  const allValues = getAllMergeFieldValues(context);
  
  // Replace all merge fields
  const regex = /\{([^}]+)\}/g;
  preview = preview.replace(regex, (match, key) => {
    const fullKey = `{${key}}`;
    const value = allValues[fullKey] || '';
    return String(value);
  });

  return preview;
};
